import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Gate for /admin/access (the access control page itself).
 *
 * Role-only check — deliberately does NOT consult the dashboard deny table.
 * Reason: this is the page admins use to UNDO a bad deny. If we gated it by
 * the "admin" dashboard key, an admin who denied themselves Admin Panel
 * would also lose access to the place where they'd go to fix it. Footgun.
 *
 * Backend endpoints in access.py follow the same rule — role check only.
 */
export default function AccessControlRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  // admin OR superadmin — superadmin is a full-power role, treat it the
  // same as admin for any page that this guard protects.
  if (!user.is_admin && !["admin", "superadmin"].includes(user.role)) {
    return <Navigate to="/welcome" replace />;
  }
  return children;
}
